import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import LineChartBase from "components/charts/LineChartBase";



const AttendanceTrend = () => {
const data = [
    { month: "May", percentage: 100 },
    { month: "Jun", percentage: 100 },
    { month: "Jul", percentage: 100 },
];

  return (
    <HeaderComponent
      title="Attendance Trend"
      description="Monthly attendance rate percentage over 6 months"
    >
      <LineChartBase 
        data={data}
        xKey="month"
        height={300}
        yKey="percentage"
        domain={[85, 100]}
        yFormatter={(v) => `${v}%`}
        tooltipFormatter={(value) => [`${value}%`, "Attendance Rate"]}
        textSize={14} 
      />
    </HeaderComponent>
  );
};

export default AttendanceTrend;
